import { alertReducerObject } from '@calendly/alert'
import { onetrustReducerObject } from '@calendly/onetrust/redux'


import { routingFormLandingReducerObject } from 'components/routing_form'
import { rootApi } from 'root-api'

import gdpr from './gdpr'
import consent from './consent'
import calendarAccounts from './calendar_accounts'
import error from './error'
import invitee from './invitee'
import calendar from './calendar'
import calendars from './calendars'
import adhocCalendar from './adhoc_calendar'
import scheduling from './scheduling'
import cancellation from './cancellation'
import analytics from './analytics'
import timezone from './timezone'
import currentUser from './current_user'
import tracking from './tracking'
import publisher from './publisher'
import segment from './segment'
import emailProvider from './email_provider'


export const reducers = {
  [rootApi.reducerPath]: rootApi.reducer,
  current_user: currentUser,
  tracking,
  error,
  invitee,
  calendar,
  calendars,
  calendar_accounts: calendarAccounts,
  adhoc_calendar: adhocCalendar,
  scheduling,
  cancellation,
  analytics,
  timezone,
  gdpr,
  consent,
  segment,
  publisherEmail: publisher,
  emailProvider,
  ...onetrustReducerObject,
  ...alertReducerObject,
  ...routingFormLandingReducerObject
}
